import React from "react";
import hero from "../../assets/images/specialBanner.png";
export default function Hero() {
  return (
      <div className="heroMonthly">
        <img src={hero} className="menu-hero" alt="Monthly Special" />
      </div>
  );
}
